import { BASE_HARVEST_REWARD, HARVEST_REWARD_MULTIPLIER } from 'Constants/Economy';
import { ThemeSettings } from 'Constants/Theme';
import { IGameState } from 'State/Game/IGameState';
import TimerStateHelper from 'State/Timer/TimerStateHelper';
import { TimerType } from 'System/Timer/TimerTypes';
import DateHelper from 'Utility/DateHelper';
import { IRewardData } from 'Utility/RewardHelper';
import { RewardType } from 'Utility/Rewards/RewardType';
import { TActionType } from 'Utility/Tracking/DataSet/Transaction';
import { PlayerTrackingHelper } from 'Utility/Tracking/TrackingHelpers/PlayerTrackingHelper';
import { PlayerStateHelper } from '../PlayerStateHelper';
import { PlayerTask } from '../PlayerTasks';
import { QuestStateHelper } from '../Quests/QuestStateHelper';
import { Quests } from '../QuestType';
import { PopupID } from '../../UI/PopupID';
import { FTUXStateHelper } from 'State/Game/FTUX/FTUXStateHelper';
import { FTUXType } from 'Player/PlayerProperty/Progress/FTUXType';
import { getCurrentLevelNumber } from '../PlayerLevelHelper';
import { FARM_UNLOCK_LEVEL } from 'Constants/Farm';
import { MAX_HARVEST_AMOUNT } from 'Constants/World';
import { WorldDataHelper } from 'Utility/WorldDataHelper';

export namespace FieldStateHelper {
    export const harvest = (
        state: IGameState,
        options?: { forceRewardAmount?: number; playAutoFlow?: boolean }
    ): IGameState => {
        const rewardData: IRewardData = {
            type: RewardType.COINS,
            value: options?.forceRewardAmount ?? getHarvestIncome(state),
        };

        let newState = TimerStateHelper.setTimer(
            state,
            TimerType.HARVEST,
            DateHelper.now !== null ? DateHelper.now : null
        );
        newState = {
            ...newState,
            playerState: QuestStateHelper.incrementQuestProgressBy(
                newState.playerState,
                Quests.HARVEST_QUEST,
                1,
                TActionType.HARVEST
            ),
        };

        newState = {
            ...newState,
            playerState: PlayerStateHelper.addStateTaskDatas(newState.playerState, [
                {
                    task: PlayerTask.HARVEST,
                    rewardData: rewardData,
                    coinAmount: state.playerState.inventory.coins,
                    playAutoFlow: options?.playAutoFlow,
                },
            ]),
        };

        // If first harvest play auto flow after harvest
        if (!FTUXStateHelper.isFtuxCompleted(newState.playerState, FTUXType.HARVEST)) {
            state = PlayerStateHelper.showLevelAutoFlowPopup(state);
        }

        return PlayerTrackingHelper.trackHarvest(newState, rewardData);
    };

    export const getLastUnlockedFieldId = (state: IGameState): string => {
        return state.playerState.fields[state.playerState.fields.length - 1];
    };

    export const unlockFields = (state: IGameState, ...fieldIds: string[]): IGameState => {
        state = fieldIds.reduce((state, id) => {
            const { sector } = WorldDataHelper.getFieldFromId(id);
            state.playerState = PlayerStateHelper.addStateTaskDatas(state.playerState, [
                {
                    task: PlayerTask.SHOW_POPUP,
                    popup: sector === 0 ? PopupID.CROP_UNLOCK_MENU : PopupID.FIELD_UNLOCKED_MENU,
                    meta: {
                        id: id,
                        newFarmUnlock: getCurrentLevelNumber(state.playerState) > FARM_UNLOCK_LEVEL,
                    },
                },
            ]);

            if (id === 'wheat_0') {
                state.playerState = PlayerStateHelper.addStateTaskDatas(state.playerState, [
                    {
                        task: PlayerTask.FIELD_FTUX,
                    },
                ]);
            } else {
                if (sector === 0) {

                }
                state.playerState = PlayerStateHelper.addStateTaskDatas(state.playerState, [
                    {
                        task: PlayerTask.SHOW_POPUP,
                        popup: PopupID.HARVEST_MENU,
                        meta: {
                            id: id,
                            playAutoFlow: true,
                        },
                        // Delay harvest popup to wait the crops growth animation to finish
                        delay: 1500,
                        waitOnGamePaused: true,
                    },
                ]);
                /*
            if (!LuckyWheelStateHelper.checkEligibility(state.playerState)) {
                state = PlayerStateHelper.showLevelAutoFlowPopup(state, {
                    delay: 5000,
                });
            } */
            }

            state = {
                ...state,
                playerState: {
                    ...state.playerState,
                    fields: [...state.playerState.fields, id],
                },
            };

            state = TimerStateHelper.setTimer(state, TimerType.HARVEST, null);

            return state;
        }, state);
        return state;
    };

    export const clearField = (state: IGameState, fieldId?: string): IGameState => {
        const updatedFieldList: string[] = [];

        if (fieldId) {
            const ids: string[] = fieldId.split('_');
            const clearWholeField: boolean = ids.length === 1;

            updatedFieldList.push(
                ...state.playerState.fields.filter((field: string) => {
                    return clearWholeField ? !(field.split('_')[0] === ids[0]) : !(field === fieldId);
                })
            );
        }

        return {
            ...state,
            playerState: {
                ...state.playerState,
                fields: updatedFieldList,
            },
        };
    };

    export const getHarvestIncome = (state: IGameState): number => {
        const fieldCount: number = state.playerState.fields.length;

        return Math.min(
            (BASE_HARVEST_REWARD + (fieldCount - 1) * HARVEST_REWARD_MULTIPLIER) *
                ThemeSettings.EVENT_HARVEST_MULTIPLIER,
            MAX_HARVEST_AMOUNT
        );
    };

    export const canHarvest = (state: IGameState): boolean => {
        const timer: Date = state.playerState.timers.get(TimerType.HARVEST);
        if (timer === null) return true;

        const now: Date = DateHelper.now;

        const timeDiff: number = now.getTime() - timer.getTime();

        return timeDiff >= DateHelper.Hour;
    };
}
